<template>
  <div class="page-container categories-list">
    <div class="page-title-container">
      <h1 class="page-title">Banners</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por título"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'config-banners-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Orden</span>
            </div>
            <div>
              <span>Título</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.position }}</span>
                </div>

                <div>
                  <span>{{ o.title }}</span>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'config-banners-edit', params: { id: o.id } }"
                >
                  Editar
                </router-link>

                <a
                  href=""
                  class="mx-2"
                  :class="{
                    'text-danger': getStatus(o.isActive).action === 'Suspender',
                  }"
                  @click.prevent="openChangeStatus(o)"
                  >{{ getStatus(o.isActive).action }}</a
                >

                <a
                  href=""
                  @click.prevent="openDelete(o)"
                  >Eliminar</a
                >
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Imagen mobile:</span
                    >
                    <div
                  class="table-image cursor-pointer"
                  @click="setShowGalleryModal(true, o.mobileImage)"
                  v-if="o.mobileImage"
                >
                  <img :src="o.mobileImage.url" :alt="o.title" />
                </div>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Imagen desktop:</span
                    >
                    <div
                  class="table-image cursor-pointer"
                  @click="setShowGalleryModal(true, o.desktopImage)"
                  v-if="o.desktopImage"
                >
                  <img :src="o.desktopImage.url" :alt="o.title" />
                </div>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Enlace:</span
                    >
                    <a :href="setUrl(o)" target="_blank">{{ setUrl(o) }}</a>
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.isActive).color}`">{{
                      getStatus(o.isActive).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th class="pl-3">Orden</th>
              <th>Título</th>
              <th>Imagen mobile</th>
              <th>Imagen desktop</th>
              <th>Enlace</th>
              <th>Estado</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">
                {{ o.position }}
              </td>

              <td class="text-center">
                {{ o.title }}
              </td>
              <td class="text-center">
                <div
                  class="table-image cursor-pointer"
                  @click="setShowGalleryModal(true, o.mobileImage)"
                  v-if="o.mobileImage"
                >
                  <img :src="o.mobileImage.url" :alt="o.title" />
                </div>
              </td>
              <td class="text-center">
                <div
                  class="table-image cursor-pointer"
                  @click="setShowGalleryModal(true, o.desktopImage)"
                  v-if="o.desktopImage"
                >
                  <img :src="o.desktopImage.url" :alt="o.title" />
                </div>
              </td>
              <td class="text-center pl-md-4">
                <a :href="setUrl(o)" target="_blank">{{ setUrl(o) }}</a>
              </td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.isActive).color}`">{{
                  getStatus(o.isActive).label
                }}</span>
              </td>

              <td class="text-center d_option pr-md-4">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      :to="{
                        name: 'config-banners-edit',
                        params: { id: o.id },
                      }"
                      text="Editar"
                    />
                    <DropdownItem
                      :text="getStatus(o.isActive).action"
                      @click="openChangeStatus(o)"
                    />
                    <DropdownItem text="Eliminar" @click="openDelete(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
        />
      </div>
    </div>
    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />

    <GalleryModal
      :show="showGalleryModal"
      @hide="setShowGalleryModal(false)"
      :image="selectedOption.url"
      v-if="selectedOption"
    />
  </div>
</template>

<script>
import {
  Alert,
  Constants,
  Util,
  ConfirmationModalMixin,
  PaginationMixin,
  FilterMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  ConfirmationModal,
  FilterMenu
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";

import { BannerService } from "@/core/services";

import GalleryModal from "@/core/components/common/GalleryModal";

export default {
  components: {
    SearchBar,
    FilterMenu,
    ConfirmationModal,
    DropdownTable,
    DropdownItem,
    GalleryModal,
  },
  mixins: [PaginationMixin, ConfirmationModalMixin, FilterMixin],
  data() {
    return {
      list: [],
      tooltipType: null,
      selectedOption: null,
      filterOptions: [
        {
          label: "Estado",
          key: "isActive",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.CategoriesStatus.ACTIVE,
            LocalConstants.CategoriesStatus.INACTIVE,
          ],
        },
      ],
      showGalleryModal: false,
    };
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "position,asc",
          search: this.search,
          ...this.filters,
        };
        const response = await BannerService.list(params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        })

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.BannersStatus);
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "delete") this.deleteBanner();
      else if (this.confirmationModal.action === "update") this.changeStatus();
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);
        const resp = (
          await BannerService.toggleStatus(
            this.selectedOption.id,
            !this.selectedOption.isActive
          )
        ).payload;

        const serie = this.list.find((o) => {
          return o.id === resp.id;
        });
        if (serie) {
          const index = this.list.indexOf(serie);
          this.$set(this.list, index, resp);
        }
        Alert.success("Estado actualizado correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado del banner?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({ acceptText: "Borrar", action: "delete" });
    },
    async deleteBanner() {
      try {
        await this.$store.dispatch("app/loading", true);
        await BannerService.delete(this.selectedOption.id);
        await this.loadData();
      } catch (ex) {
        console.error(ex);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    setShowGalleryModal(value, image) {
      if (value) {
        this.selectedOption = image;
      } else {
        this.selectedOption = null;
      }

      this.showGalleryModal = value;
    },
    setUrl(item) {
      let bannerType = LocalConstants.BannersRedirectTypes;
      let url = item.redirectUrl;

      if (item.redirectType == bannerType.CATEGORY.key) {
        url = `${process.env.VUE_APP_WEB_URL}/c/${item.redirectUrl}`;
      } else if (item.redirectType == bannerType.PRODUCT.key) {
        url = `${process.env.VUE_APP_WEB_URL}/p/${item.redirectUrl}`;
      }

      return url;
    },
  },
  computed: {
    showFiltersList() {
      return Object.keys(this.filters).length >= 1;
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="stylus" scoped></style>
